import axios, { type AxiosInstance } from 'axios';

const API_URL = (import.meta.env.VITE_API_BASE_URL as string) ?? 'http://localhost:8081';

export type ApiClient = AxiosInstance;

export function createApiClient(baseURL: string = API_URL): ApiClient {
  return axios.create({
    baseURL,
    withCredentials: true,
    headers: { 'Content-Type': 'application/json' },
  });
}

export const api = createApiClient();
